<template>
    <div v-if="onboardings.length>0">
    <v-card class="score-chart mx-1" v-if="!loading&&layoutType==='agent'">
        <v-card-title class="caption-font">
            <span class="caption-font white--text"><v-avatar size="40" class="change mr-4"><v-icon color="white">mdi-home-alert-outline</v-icon></v-avatar>Accommodations with status CHK that need verification: {{ onboardings.length }}</span>
            <v-spacer></v-spacer>
            <v-btn v-if="onboardings.length>0&&!showDetails" color="primary" text small v-on:click="showDetails = !showDetails" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> View list</v-btn>
            <v-btn v-if="onboardings.length>0&&showDetails"  color="primary" text small v-on:click="showDetails = !showDetails" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> Hide list</v-btn>
        </v-card-title>
        <v-card-text v-if="showDetails">
            <v-row class="ma-0 pa-0">
                <v-col cols="1" class="acconame ma-0 pa-0 font-weight-bold">
                    Accommodation
                </v-col>
                <v-col cols="4" class="acconame ma-0 pa-0 font-weight-bold">
                    Name
                </v-col>
                <v-col cols="4" class="acconame ma-0 pa-0 font-weight-bold">
                    Agent
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0 font-weight-bold">
                    Onboarding
                </v-col>
            </v-row>
            <v-divider/>
            <v-row v-for="item in onboardings" :key="item.encrid" class="ma-0 pa-0">
                <v-col cols="1" class="ma-0 pa-0">
                    <span class="accolink blue--text text-decoration-underline" @click="openSubScreen('/huis/onhuis/' + item.huis_encrid)">{{ item.huis_code }}</span>
                </v-col>
                <v-col cols="4" class="acconame ma-0 pa-0">
                    {{ item.huis_naam }}
                </v-col>
                <v-col cols="4" class="acconame ma-0 pa-0">
                    {{ item.huis_agent }}
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0">
                    <span class="accolink blue--text text-decoration-underline" @click="openSubScreen('/wzvz/wzvz_cs_overview/Agent')">View requests</span>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                onboardings: [],
                layoutType: "agent",
                showDetails: false,
                loading: true,
            }
        },
        mounted() { // set up event bus listener here on created event
            this.getOnboardingOverview();
        },
        methods:{
            getOnboardingOverview(){
                this.$axios.post("ares/json/ares/syst/dashboard/getOnboardingOverview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getOnboardingOverview"
                    },
                    getOnboardingOverview: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.onboardings = res.data.getOnboardingOverview;
                        this.loading = false;
                    }
                });
            },
            toggle() {
                this.showDetails = !this.showDetails
            },
            openSubScreen(path) {
                let route = this.$router.resolve({ path: path });
                window.open(route.href, '_blank');
            },
        }
    }
</script>

<style scoped>
    .score-chart {
        background-image: linear-gradient(#a1e8ed, #def5f9) !important;
        background-size: cover !important;
    }

    .change {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid white;
        color: white;
        cursor: default;
    }

    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }

    .accolink {
        cursor: pointer;
    }

    .acconame {
        cursor: default;
    }
    .listHeader {
        font-weight: bold;
    }
</style>